import { useEffect, useState } from "react";

const COLORS = ["#7C5CFF", "#B8A4FF", "#7C5CFF", "#B8A4FF", "#5AC8FA", "#5AC8FA", "#B8A4FF"];

export default function Confetti({ active, count = 32 }) {
  const [pieces, setPieces] = useState([]);

  useEffect(() => {
    if (!active) return;
    const pcs = Array.from({ length: count }, (_, i) => ({
      id: `${Date.now()}-${i}`,
      left: 50 + (Math.random() - 0.5) * 80,
      cx: (Math.random() - 0.5) * 220,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      delay: Math.random() * 0.25,
      rotate: Math.random() * 360,
    }));
    setPieces(pcs);
    const t = setTimeout(() => setPieces([]), 2500);
    return () => clearTimeout(t);
  }, [active]);

  if (!pieces.length) return null;
  return (
    <div className="pointer-events-none fixed inset-0 z-50 overflow-hidden">
      {pieces.map((p) => (
        <span
          key={p.id}
          className="confetti-dot"
          style={{
            left: `${p.left}%`,
            background: p.color,
            "--cx": `${p.cx}px`,
            animationDelay: `${p.delay}s`,
            transform: `rotate(${p.rotate}deg)`,
          }}
        />
      ))}
    </div>
  );
}
